import { Routes } from "react-router-dom";

import { renderRouteTree } from "./routeTree";

export interface PublicRoutesProps {
  readonly isAdminDomain: boolean;
}

export function PublicRoutes({ isAdminDomain }: PublicRoutesProps) {
  return <Routes>{renderRouteTree({ isAdminDomain })}</Routes>;
}

// Default export for lazy loading (Phase 5.1: Code Splitting)
export default PublicRoutes;
